module.exports = __webpack_public_path__ + "static/2-41aa1bac7235542d44664a82fcca0279.jpg";